import React from 'react'

import useAxios, { mutate, cache } from 'hooks/useAxios'
import { toast } from 'libs/toast'
import { SurveyDeliveryMethodInput } from '.'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setSurveyFromId } from 'actions'

export function SurveyDeliveryMethodInputContainer() {
  const { surveyId } = useParams()
  const { fetch: updateSurvey, loading } = useAxios({
    url: `account/survey/${surveyId}/`,
    method: 'patch',
    skip: true,
  })
  const dispatch = useDispatch()

  function handleChange(embedIntegration) {
    const { name: deliveryType, connectorId } = embedIntegration
    updateSurvey({
      data: {
        type: deliveryType,
        connector: connectorId,
      },
    })
      .then(() => {
        const surveyCacheKey = `account/survey/${surveyId}/`
        const cachedSurvey = cache.get(surveyCacheKey)
        const updatedSurvey = {
          ...(cachedSurvey || {}),
          id: surveyId,
          type: deliveryType,
          connector: connectorId,
        }
        mutate(surveyCacheKey, updatedSurvey, false)
        dispatch(setSurveyFromId(updatedSurvey))
      })
      .catch((e) => {
        console.error(e)
        toast.error('Oops, there was an error updating the delivery method. Please try again.')
      })
  }

  return (
    <SurveyDeliveryMethodInput onChange={handleChange} loading={loading} enableOneoffEmailSurvey />
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/SurveyDeliveryMethodInput/container.js